import { m } from 'framer-motion'
import { styled } from '@mui/material/styles'
import { Container, Stack } from '@mui/material'
// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    height: '15vh', // 15vh on desktop,
    padding: 0,
  },
  height: '1vh',
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: '7px',
    backgroundColor: '#fff',
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: '14px',
    backgroundColor: '#fff',
  },
}))

const SVG = styled(m.img)(({ theme }) => ({
  width: '13%',
  height: 'auto', // Adjust this as needed
  objectFit: 'contain',
  padding: theme.spacing(1),
  // Add more styling as needed
}))

const StyledContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    height: '15vh', // 15vh on desktop,
  },
  height: '1vh', // 15vh on desktop,
  padding: 0,
}))

const APL = 'assets/svg/APL.svg'
const CMA_CGM = 'assets/svg/cma-cgm.svg'
const COSCO = 'assets/svg/cosco.svg'
const EVERGREEN = 'assets/svg/evergreen.svg'
const HAPAG_LLOYD = 'assets/svg/hapag-lioyd.svg'
const MAERSK = 'assets/svg/maersk.svg'
const MSC = 'assets/svg/msc.svg'
const NYK_LINE = 'assets/svg/nyk-line.svg'
const ONE = 'assets/svg/one.svg'
const PIL = 'assets/svg/pil.svg'
const YANG_MING = 'assets/svg/yang-ming.svg'

// SVG sources
const svgSources = [HAPAG_LLOYD, CMA_CGM, COSCO, EVERGREEN, APL, MAERSK, MSC, NYK_LINE, ONE, PIL, YANG_MING]

// ----------------------------------------------------------------------
export default function HomeShippingLines() {
  return (
    <StyledRoot>
      <StyledContainer component={m.div}>
        <Stack
          spacing={2}
          direction="row"
          justifyContent="center" // Align the icons in the center
        >
          {svgSources.map((src, index) => (
            <SVG key={index} src={src} alt={`Shipping Line ${index}`} />
          ))}
        </Stack>
      </StyledContainer>
    </StyledRoot>
  )
}
